import AppProperties from './AppProperties';
import Color from './Color';
import Configuration from './Configuration';
import CubicBezier from './CubicBezier';
import EditProperty from './EditProperty';
import Layers from './Layers';
import Logs from './Logs';
import Palette from './Palette';
import PresetDetails from './PresetDetails';
import Presets from './PresetList';
import Rotation from './Rotation';
import Texture from './Texture';

const modules = {
  'edit-bezier': CubicBezier,
  'edit-layers': Layers,
  'edit-property': EditProperty,
  'edit-rotation': Rotation,
  'edit-tested-texture': Texture,
  'palette-details': Color,
  'preset-details': PresetDetails,
  configuration: Configuration,
  logs: Logs,
  palette: Palette,
  presets: Presets,
  appProperties: AppProperties,
};

export default modules;
